import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTwitterLogo48WhiteBg = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 48,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.608 36.66c10.644 0 16.464-8.82 16.464-16.464 0-.252 0-.504-.012-.744a11.855 11.855 0 0 0 2.892-3 11.745 11.745 0 0 1-3.324.912 5.783 5.783 0 0 0 2.544-3.204 11.718 11.718 0 0 1-3.672 1.404 5.758 5.758 0 0 0-4.224-1.824 5.787 5.787 0 0 0-5.784 5.784c0 .456.048.9.156 1.32-4.812-.24-9.072-2.544-11.928-6.048a5.805 5.805 0 0 0-.78 2.904 5.76 5.76 0 0 0 2.58 4.812 5.684 5.684 0 0 1-2.616-.72v.072a5.793 5.793 0 0 0 4.644 5.676c-.48.132-.996.204-1.524.204-.372 0-.732-.036-1.092-.108a5.778 5.778 0 0 0 5.4 4.02 11.632 11.632 0 0 1-7.188 2.472c-.468 0-.924-.024-1.38-.084a16.122 16.122 0 0 0 8.844 2.616Z",
    fill: props.color || "#58595B"
  })]
}));
export default SvgTwitterLogo48WhiteBg;